<div class="custom-field" [id]="field?.fieldColumn">
	<ng-container *ngIf="(control?.value | objectKeys : [])?.length === 0">
		<div fxFlex="1 1" fxLayout="row" fxLayoutAlign="start start">
			<mat-form-field class="text-box" [floatLabel]="field?.additionalMetaData?.fieldConfig?.floatLabel"
				[appearance]="field?.additionalMetaData?.fieldConfig?.appearance">
				<mat-label *ngIf="![null, undefined, ''].includes(field?.fieldCaption) && field?.additionalMetaData?.showLabel">
					{{field?.fieldCaption}}
				</mat-label>
				<input matInput [placeholder]="field.fieldPlaceholder" [formControl]="control" [pattern]="validationRegex"
					[matTooltip]="(control.disabled) ? '' : field.fieldHelpText" [required]="field.isRequired"
					[readonly]="field.isReadonly" type="text" (ngModelChange)="fieldChange()"
					[autocomplete]="field?.additionalMetaData?.autoFill" (paste)="onPaste($event)">
				<button *ngIf="field?.embedAction?.type === 'button' && !loader" [disabled]="!control?.valid || !control?.value"
					mat-raised-button matSuffix class="cursor-pointer" [matTooltip]="field?.embedAction?.tooltip" type="button"
					(click)="embed()">
					{{field?.embedAction?.caption}}
				</button>
				<mat-spinner *ngIf="loader" diameter="20" matSuffix></mat-spinner>
				<button *ngIf="field?.embedAction?.type === 'icon' && !loader"
					[disabled]="control?.errors?.pattern || !control?.value" mat-icon-button matSuffix class="cursor-pointer"
					[matTooltip]="field?.embedAction?.tooltip" type="button" (click)="embed()">
					<mat-icon>{{field?.embedAction?.icon}}</mat-icon>
				</button>
				<button mat-icon-button *ngIf="field?.fieldIcon?.prefix && field?.fieldIcon?.prefix?.icon" matPrefix
					class="cursor-pointer" (click)="fieldIconData(field?.fieldIcon?.prefix)"
					[matTooltip]="field?.fieldIcon?.prefix?.caption" [disabled]="field?.fieldIcon?.prefix?.disabled"
					type="button">
					<mat-icon>{{field?.fieldIcon?.prefix?.icon}}</mat-icon>
				</button>
				<p *ngIf="field?.fieldIcon?.prefix?.caption && !field?.fieldIcon?.prefix?.icon" matSuffix>
					{{field?.fieldIcon?.prefix?.caption}}</p>
				<mat-hint *ngIf="(control.untouched || control.valid) && ![null, undefined, ''].includes(field.fieldHelpText)">
					{{field.fieldHelpText}}</mat-hint>
				<mat-error *ngIf="control.errors && control.touched"
					[innerHtml]="controlFunctions.validationMsg(control, field)">
				</mat-error>
			</mat-form-field>

			<ng-container *ngIf="field?.helpLine?.length">
				<app-help-line [helpLineData]="field.helpLine" fxLayout="row" fxLayoutAlign="start start"
					(helpLineEmit)="helpLineData($event)"></app-help-line>
			</ng-container>
		</div>
	</ng-container>

	<ng-container *ngIf="(control?.value | objectKeys : [])?.length">
		<div fxFlex="1 1" fxLayout="row" fxLayoutAlign="space-between stretch" fxLayoutGap="10px" fxLayout.xs="column"
			fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="5px" class="embed-view">
			<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" fxLayout.xs="column"
				fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="5px">
				<ng-container *ngIf="control?.value?.image">
					<div fxFlex="0 0 150px" fxFlex.xs="100%">
						<div class="thumbnail">
							<img [src]="control?.value?.image" alt="">
						</div>
					</div>
				</ng-container>
				<div fxFlex="1 1 auto" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
					<ng-container *ngIf="control?.value?.title">
						<a [attr.href]="control?.value?.link" target="_blank"
							class="entity-title linkable">{{control?.value?.title}}</a>
					</ng-container>
					<ng-container *ngIf="control?.value?.link && field?.additionalMetaData?.showLink">
						<a [attr.href]="control?.value?.link" target="_blank"
							class="embed-url linkable">{{control?.value?.link}}</a>
					</ng-container>
					<ng-container *ngIf="control?.value?.description && field?.additionalMetaData?.showDescription">
						<div class="embed-desc">{{control?.value?.description}}</div>
					</ng-container>
				</div>
				<div class="btn-holder"
					[ngClass]="{'fx-row fx-end-start' : !detectDevice?.resolutionState$?.value?.xs, 'xs' : detectDevice?.resolutionState$?.value?.xs}">
					<button class="remove-btn" mat-icon-button type="button" (click)="clearEmbed()" class="remove-btn">
						<mat-icon>clear</mat-icon>
					</button>
				</div>
			</div>
		</div>
	</ng-container>
</div>
